import React from "react";
import { Link } from "redux-little-router";

export const Footer = () => {
  return (
    <section className="footer__wrapper mt2 p1">
      <ul className="footer__nav">
        <li className="footer__nav_item">
          <Link href="/" className="footer__nav_link">
            Privacy Hub
          </Link>
        </li>
        <li className="footer__nav_item">
          <Link href="/privacy-policy" className="footer__nav_link">
            Privacy Policy
          </Link>
        </li>
        <li className="footer__nav_item">
          <Link href="/cookie-policy" className="footer__nav_link">
            Cookie Policy
          </Link>
        </li>
        <li className="footer__nav_item">
          <a
            href="https://www.sainsburys.co.uk/accessibility"
            rel="noopener noreferrer"
            target="_blank"
            className="footer__nav_link"
          >
            Accessibility
          </a>
        </li>
        <li className="footer__nav_item">
          <a
            href="https://www.sainsburys.co.uk/terms"
            rel="noopener noreferrer"
            target="_blank"
            className="footer__nav_link"
          >
            Terms &amp; Conditions
          </a>
        </li>
      </ul>
    </section>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/common/Footer.js